<template>
  <div class="componentRoot">
    <v-container fluid v-if="baseData" class="mb-3 ml-1">
      <v-row>
        <v-col :cols="cardCols" class="pb-0 pl-2"
          :class="{ 'pr-3': searchBarCols == 12, 'pr-0': searchBarCols != 12, }">
          <v-card class="dashboardCard hoverable" flat @click="showBillWarning">
            <h3>{{ $t("basics.needsToBeBilled") }}</h3>
            <span style="display: flex; justify-content: space-between; align-items: center;">
              <h1 style="color:rgb(var(--v-theme-primary))">
                {{ baseData.open }}</h1>
              <v-icon v-if="$checkFunctionPermission(['bill_post_detail'])" size="xxx-large"
                color="primary">mdi-reload</v-icon>
            </span>

          </v-card>
        </v-col>
        <v-col :cols="cardCols" class="pb-0 pl-2"
          :class="{ 'pr-3': searchBarCols == 12, 'pr-2': searchBarCols != 12, }">
          <v-card class="dashboardCard hoverable" flat @click="applyFilter('pending')">
            <h3>{{ $t("basics.notPaid") }}</h3>
            <span style="display: flex; align-items: center;">
              <h1 class=mr-2 style="color:rgb(var(--v-theme-primary))">
                {{ baseData.unpaid }}</h1> ({{ baseData.unpaid_sum.toFixed(2) }}€)
            </span>
          </v-card>
        </v-col>
        <v-col :cols="cardCols" class="pb-0"
          :class="{ 'pr-4': searchBarCols != 12, 'pr-3': searchBarCols == 12, 'pl-2': searchBarCols == 12, 'pl-0': searchBarCols != 12 }">
          <v-card class="dashboardCard hoverable" flat @click="applyFilter('overdue')">
            <h3>{{ $t("basics.overdue") }}</h3>
            <span style="display: flex; align-items: center;">
              <h1 class=mr-2 style="color:rgb(var(--v-theme-primary))">
                {{ baseData.overdue }}</h1> ({{ baseData.overdue_sum.toFixed(2) }}€)
            </span>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <ButtonRowVue :noSpacer="true" :class="{ 'mt-1': searchBarCols == 12 }">
      <template v-slot:leftSide>
        <v-col class="pr-0" :cols="searchBarCols" :class="{ 'pr-2': searchBarCols == 12 }">
          <SearchBarVue :labelArray="['basics.name', 'basics.number']" @search="updateSearchQueue" />
        </v-col>
      </template>
      <v-col :cols="filterCols" class="pr-0" :class="{ 'mt-2': searchBarCols == 12, 'pl-2': searchBarCols != 12 }"
        style="display: flex; flex-direction: column;">
        <v-card @click="applyFilter()" style="flex-grow: 1; display: flex; align-items: center;"
          class="primaryButton filterButton" flat :style="{ 'justify-content': isMobile ? 'center' : 'left' }"
          :class="{ billingFilterButton: activeStatus === undefined, 'px-3': searchBarCols != 12, 'px-1': searchBarCols == 12 }">
          {{ $t("basics.all") }}
        </v-card>
      </v-col>
      <v-col :cols="filterCols" class="pr-0 pl-2" :class="{ 'mt-2': searchBarCols == 12 }"
        style="display: flex; flex-direction: column;">
        <v-card @click="applyFilter('created')" style="flex-grow: 1; display: flex; align-items: center;"
          class="primaryButton px-3 filterButton" flat :class="{ billingFilterButton: activeStatus === 'created' }"
          :style="{ 'justify-content': isMobile ? 'center' : 'left' }">
          {{ $t("constants.billing_status_created") }}
        </v-card>
      </v-col>
      <v-col :cols="filterCols" class="pr-0 pl-2" :class="{ 'mt-2': searchBarCols == 12, 'pr-2': filterCols == 4 }"
        style="display: flex; flex-direction: column;">
        <v-card @click="applyFilter('pending')" style="flex-grow: 1; display: flex; align-items: center;"
          class="primaryButton filterButton" flat :style="{ 'justify-content': isMobile ? 'center' : 'left' }"
          :class="{ billingFilterButton: activeStatus === 'pending', 'px-3': searchBarCols != 12, 'px-1': searchBarCols == 12 }">
          {{ $t("constants.billing_status_pending") }}
        </v-card>
      </v-col>
      <v-col :cols="filterCols" class="pr-0 pl-2" :class="{ 'mt-2': searchBarCols == 12, 'pl-3': filterCols == 4 }"
        style="display: flex; flex-direction: column;">
        <v-card @click="applyFilter('overdue')" style="flex-grow: 1; display: flex; align-items: center;"
          class="primaryButton filterButton" flat :style="{ 'justify-content': isMobile ? 'center' : 'left' }"
          :class="{ billingFilterButton: activeStatus === 'overdue', 'px-3': searchBarCols != 12, 'px-1': searchBarCols == 12 }">
          {{ $t("constants.billing_status_overdue") }}
        </v-card>
      </v-col>
      <v-col :cols="filterCols" class="pl-2" :class="{ 'mt-2': searchBarCols == 12, 'pr-2': searchBarCols == 12 }"
        style="display: flex; flex-direction: column;">
        <v-card @click="applyFilter('paid')" style="flex-grow: 1; display: flex; align-items: center;"
          class="primaryButton filterButton" flat :style="{ 'justify-content': isMobile ? 'center' : 'left' }"
          :class="{ billingFilterButton: activeStatus === 'paid', 'px-3': searchBarCols != 12, 'px-1': searchBarCols == 12 }">
          {{ $t("constants.billing_status_paid") }}
        </v-card>
      </v-col>
    </ButtonRowVue>

    <TableVue :numPages="numPages" @switchPage="switchPage" id="billTable" :page="currPage" :total="totalCount"
      :resetPage="resetPage">
      <thead>
        <tr>
          <th class="text-left" v-if=isMobile>
            <b style="font-size: medium">{{ $t("basics.status") }}</b>
          </th>
          <th class="text-left">
            <b style="font-size: medium">{{ $t("basics.number") }}</b>
          </th>
          <th class="text-left" v-if=!isMobile>
            <b style="font-size: medium">{{ $t("basics.receiver") }}</b>
          </th>
          <th class="text-left" v-if=!isMobile>
            <b style="font-size: medium">{{ $t("basics.sum") }}</b>
          </th>
          <th class="text-left">
            <b style="font-size: medium" v-if="!isMobile"> {{ $t("basics.dueDate") }}</b>
            <b style="font-size: medium" v-else>{{ $t("basics.dueDateShort") }}</b>
          </th>
          <th class="text-left" v-if=!isMobile>
            <b style="font-size: medium">{{ $t("basics.status") }}</b>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="bill in bills" @click="showEditBill($event, bill)" :key="bill.id">
          <td v-if="isMobile">
            <div style="width: 20px; height: 20px; border-radius: 50%"
              :class="[backgroundColorClasses[bill.display_status], fontClasses[bill.display_status]]"></div>
          </td>
          <td>
            {{ bill.billing_number }}
          </td>
          <td v-if=!isMobile>
            {{ bill.receiver.full_name }}
          </td>
          <td v-if=!isMobile>
            {{ bill.total_sum.toFixed(2) }}€
          </td>
          <td>
            {{ bill.display_due_date }}
          </td>
          <td v-if="!isMobile">
            <div class="px-2 rounded-xl" style="width: fit-content;"
              :class="[backgroundColorClasses[bill.display_status], fontClasses[bill.display_status]]">{{
                $t("constants.billing_status_" + bill.display_status) }}</div>
          </td>
          <td style="text-align: end;">
            <div style="display: flex">
              <v-tooltip :text="$t('messages.markBillHasBeenPaid')"
                v-if="bill.display_status != 'created' && bill.display_status != 'paid'">
                <template v-slot:activator="{ props }">
                  <v-icon @click="markAsPaid($event, bill)" color="primary" size="x-large"
                    class="mr-4 regular-transparency" v-bind="props">mdi-check</v-icon>
                </template>
              </v-tooltip>

              <v-tooltip :text="$t('messages.resendBillingMail')"
                v-if="bill.display_status != 'created' && bill.display_status != 'paid'">
                <template v-slot:activator="{ props }">
                  <v-icon @click="showBillMailWarning($event, bill)" color="primary" size="x-large"
                    class="mr-4 regular-transparency" v-bind="props">mdi-email-alert</v-icon>
                </template>
              </v-tooltip>

              <v-tooltip :text="$t('messages.openInNewTab')" v-if="bill.has_file">
                <template v-slot:activator="{ props }">
                  <v-icon color="primary" size="x-large" @click="getBillFile($event, bill, true)"
                    class="mr-4 regular-transparency" v-bind="props">mdi-eye-outline</v-icon>
                </template>
              </v-tooltip>

              <v-tooltip :text="$t('messages.download')" v-if="bill.has_file">
                <template v-slot:activator="{ props }">
                  <v-icon color="primary" size="x-large" @click="getBillFile($event, bill, false)"
                    class="mr-4 regular-transparency" style="margin-top: 2px" v-bind="props">mdi-download</v-icon>
                </template>
              </v-tooltip>

              <v-tooltip :text="$t('messages.regenerate')" v-if="bill.display_status != 'paid' && bill.display_status != 'created'">
                <template v-slot:activator="{ props }">
                  <v-icon color="primary" size="x-large" @click="regenerateBillFile($event, bill)"
                    class="regular-transparency" style="margin-top: 0px" v-bind="props">mdi-reload</v-icon>
                </template>
              </v-tooltip>
            </div>
          </td>
        </tr>
        <tr v-if="!bills || bills.length == 0">
          <td colspan="10">
            <p>
              <i>{{ $t("messages.noItems") }}</i>
            </p>
          </td>
        </tr>
      </tbody>
    </TableVue>

    <LoadingScreenVue :loading="loading" />

    <BillWarningVue :refreshDisplay="billWarningDrawer" @close="hideDrawers" />
    <BillMailWarningVue :refreshDisplay="billMailWarningDrawer" :billData="activeBill" @close="hideDrawers" />

    <BillEditVue :billData=activeBill :refreshDisplay="billEditDrawer" @close="hideDrawers"
    />
    <!-- :readonly="activeBill && activeBill.display_status != 'created'"  -->
  </div>
</template>

<script>
import BillWarningVue from "../../../components/accounting/BillWarning.vue"
import BillMailWarningVue from "../../../components/accounting/BillMailWarning.vue"
import BillEditVue from "../../../components/accounting/BillEdit.vue"

export default {
  name: "billList",

  data() {
    return {
      bills: [],
      baseData: undefined,

      numPages: undefined,
      currPage: 1,
      pageSize: 10,
      totalCount: undefined,
      resetPage: 0,

      sortBy: "number",
      sortDirection: false,

      activeBill: undefined,
      billEditDrawer: 0,
      billWarningDrawer: 0,
      billMailWarningDrawer: 0,

      loading: false,

      backgroundColorClasses: {
        created: "yellow-background",
        pending: "light-blue-background",
        overdue: "red-background",
        paid: "green-background"
      },

      fontClasses: {
        created: "yellow-font",
        pending: "blue-font",
        overdue: "red-font",
        paid: "green-font"
      },

      activeStatus: undefined,

      searchQueue: "",
      filterQuery: "",
    };
  },

  computed: {
    cardCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 4;
        case "md":
          return 4;
        case "lg":
          return 4;
        case "xl":
          return 4;
        case "xxl":
          return 4;
        default:
          return 4;
      }
    },
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },
    searchBarCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return undefined;
        case "lg":
          return undefined;
        case "xl":
          return undefined;
        case "xxl":
          return undefined;
        default:
          return undefined;
      }
    },
    filterCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 4;
        case "sm":
          return 4;
        case "md":
          return "auto";
        case "lg":
          return "auto";
        case "xl":
          return "auto";
        case "xxl":
          return "auto";
        default:
          return "auto";
      }
    },
  },

  components: {
    BillWarningVue,
    BillEditVue,
    BillMailWarningVue
  },

  methods: {
    showBillWarning() {
      if (!this.$checkFunctionPermission(['bill_post_detail'])) {
        return
      }

      if (!this.baseData.open) {
        return
      }

      this.billWarningDrawer++
    },
    applyFilter(status) {
      this.activeStatus = status

      this.fetchBills()
    },
    updateSearchQueue(value) {
      this.resetPage++;
      this.currPage = 1;
      this.searchQueue = value;

      this.fetchBills();
    },
    getReadableDate(dateString) {
      if (!dateString) {
        return ""
      }
      return this.$moment(dateString).format("DD.MM.YYYY");
    },
    getReadableDateTime(dateString) {
      return this.$moment(dateString).format("DD.MM.YYYY HH:mm");
    },
    setLoading(value) {
      this.loading = value;
    },
    switchPage(data) {
      this.currPage = data;

      this.fetchBills();
    },
    switchSortBy(val) {
      if (this.sortBy != val) {
        this.sortBy = val;
        this.sortDirection = true;
      } else {
        this.sortDirection = !this.sortDirection;
      }

      this.currPage = 1;

      this.fetchBills();
    },
    showEditBill(event, bill = undefined) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }

      this.activeBill = bill;

      this.billEditDrawer++;
    },
    openFile(bill, newTab) {
      if (newTab) {
        window.open(bill.blob, "_blank");
      } else {
        const a = document.createElement("a");
        a.href = bill.blob;
        a.download = bill.filename;
        document.body.appendChild(a);
        a.click();
      }
    },
    regenerateBillFile(event, bill) {
      event.stopPropagation();
      event.preventDefault();

      this.loading = true

      this.axios.post(this.axios.defaults.baseURL + "user/bills/regenerate/", {
        id: bill.id
      })
        .then((resp) => {
          this.loading = false

          this.fetchBills()
        })
        .catch((e) => {
          console.log(e);
          this.loading = false
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });

    },
    getBillFile(event, bill, newTab) {
      event.stopPropagation();
      event.preventDefault();

      if (bill.blob) {
        this.openFile(bill, newTab)
      }
      else {
        this.axios({
          method: "POST",
          url: this.axios.defaults.baseURL + "user/bills/file/",
          responseType: "blob", // Important! Set the response type to 'blob' for binary data
          data: {
            id: bill.id,
          },
        })
          .then((resp) => {
            bill.blob = URL.createObjectURL(resp.data);

            const contentDisposition = resp.headers["content-disposition"];
            const filenameMatch = /filename=([^"]+)/.exec(contentDisposition);
            bill.filename = filenameMatch[1]

            this.openFile(bill, newTab)
          })
          .catch((e) => {
            console.log(e);
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
          });
      }
    },
    showBillMailWarning(event, bill) {
      event.stopPropagation();
      event.preventDefault();

      this.activeBill = bill;

      this.billMailWarningDrawer++;
    },
    hideDrawers(data) {
      this.billEditDrawer = 0;
      this.billMailWarningDrawer = 0;
      this.billWarningDrawer = 0;

      if (data) {
        this.fetchData();
      }
    },
    markAsPaid(event, bill) {
      event.stopPropagation()
      event.preventDefault()

      let paidStatus
      for (let i = 0; i < this.baseData.statuses.length; i++) {
        console.log(this.baseData.statuses[i])
        if (this.baseData.statuses[i].value == "paid") {
          paidStatus = this.baseData.statuses[i].key
          break
        }
      }

      if (paidStatus === undefined) {
        return
      }

      let formData = {
        id: bill.id,
        status: paidStatus
      }

      this.axios
        .patch(
          this.axios.defaults.baseURL + "user/bills/patch/",
          formData
        )
        .then((resp) => {
          this.fetchData()
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    fetchData() {
      this.setLoading(true);


      this.fetchBills().then(() => {
        this.fetchBaseData()
      })
    },
    fetchBaseData() {
      this.setLoading(true);
      this.axios
        .get(this.axios.defaults.baseURL + "user/bills/stats/")
        .then((resp) => {
          this.baseData = resp.data
          this.setLoading(false);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
          this.setLoading(false);
        });
    },
    fetchBills() {
      this.setLoading(true);
      return new Promise((resolve, reject) => {

        let searchParams =
          "?page=" +
          this.currPage +
          "&order=" +
          this.sortBy +
          "&direction=" +
          (this.sortDirection ? "up" : "down");

        if (this.searchQueue) {
          searchParams += "&query=" + this.searchQueue;
        }

        if (this.activeStatus) {
          searchParams += "&status=" + this.activeStatus
        }

        this.axios
          .get(this.axios.defaults.baseURL + "user/bills/" + searchParams)
          .then((resp) => {
            this.bills = resp.data.results;
            this.totalCount = resp.data.count;

            if (resp.data.results.length == 0) {
              this.numPages = 0;
            } else if (this.currPage == 1) {
              this.numPages = Math.ceil(resp.data.count / resp.data.results.length);
            }

            this.setLoading(false);
            resolve()
          })
          .catch((e) => {
            console.log(e);
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
            this.setLoading(false);
            reject()
          });
      })
    }
  },

  mounted() {
    this.fetchData();
  },
};
</script>
